import { addProviderBreaks, deleteProviderBreaks, getProviderBreaks } from '@guryou/api-client';
import { getProviderScheduleApiRequest, saveResourceScheduleApiRequest } from '@guryou/api-client-gql';

import { executeApiCall } from '../core';
import { PROVIDER_ADD_BREAKS, PROVIDER_ADD_SCHEDULE, PROVIDER_DELETE_BREAKS, PROVIDER_GET_BREAKS, PROVIDER_GET_SCHEDULE } from '../types';

import { execute } from './actionWrapper';

const twoUndefined = [undefined, undefined];

const getProviderSchedules = () => async dispatch => execute(dispatch, () => getProviderScheduleApiRequest(), PROVIDER_GET_SCHEDULE, false);

const getProviderBreak = () => async dispatch => dispatch(executeApiCall(getProviderBreaks(), PROVIDER_GET_BREAKS, ...twoUndefined, true));

const addProviderSchedules =
  (data, silent = false) =>
  async dispatch =>
    execute(dispatch, () => saveResourceScheduleApiRequest(0, data), PROVIDER_ADD_SCHEDULE, !silent);

const addProviderBreak = (data, silent) => async dispatch =>
  dispatch(executeApiCall(addProviderBreaks(data), PROVIDER_ADD_BREAKS, silent, undefined, true));

const deleteProviderBreak = () => async dispatch => dispatch(executeApiCall(deleteProviderBreaks(), PROVIDER_DELETE_BREAKS));

export { addProviderBreak, addProviderSchedules, deleteProviderBreak, getProviderBreak, getProviderSchedules };
